import './index.css';
import '@ant-design/v5-patch-for-react-19';
import '@fortawesome/fontawesome-svg-core/styles.css';
import './config/dayjs';
import './config/iconRegistry';

import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { config } from '@fortawesome/fontawesome-svg-core';

import { StyleProvider } from '@ant-design/cssinjs';
import { App, ConfigProvider } from 'antd';
import esES from 'antd/es/locale/es_ES';
import ThemeProvider from './config/themeProvider';

import Spinner from './app/shared/components/common/spinner/Spinner';

import AntMessaging from './shared/AntMessagingBinder';
import ErrorBoundary from './pages/error/ErrorBoundary';

import QueryClientProvider from './providers/QueryClientProvider';

import router from './router';

config.autoAddCss = false;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <StyleProvider hashPriority="high">
      <ConfigProvider theme={ThemeProvider} locale={esES}>
        <QueryClientProvider>
          <App className="App min-h-screen" notification={{ placement: 'topRight', maxCount: 2 }} message={{ duration: 3, maxCount: 2 }}>
            <AntMessaging />
            <Spinner />
            <RouterProvider router={router} />
          </App>
        </QueryClientProvider>
      </ConfigProvider>
    </StyleProvider>
  </ErrorBoundary>
);
